module.exports = __webpack_public_path__ + "static/img/1.431d663.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/18/eng/1.png
// module id = CVRI
// module chunks = 0